import { gsap } from 'gsap';

export const wheelAnim = (title) => {

	const chars = [...title.querySelectorAll(".char")];
	const tl = gsap.timeline();

	chars.forEach((char) => {
		const childCount = char.children.length;
		if (childCount > 1) {
			const yPercent = -((childCount - 1) / childCount) * 100;
			tl.to(char, {
				yPercent,
				duration: 3,
				ease: "power2.inOut",
			}, 0);
		}
	});

	return tl;
}